export default __webpack_public_path__ + "static/media/empty-box.2f71d613.png";